// extracted by mini-css-extract-plugin
export var animated = "NewsletterButton-module--animated--35c4d";
export var btn = "NewsletterButton-module--btn--ece3b";
export var container = "NewsletterButton-module--container--2ae3e";
export var icon = "NewsletterButton-module--icon--608df";
export var shake = "NewsletterButton-module--shake--63356";